import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Container, Paper, Typography, Alert } from '@mui/material';
import api from '../../utils/api';
import useThemeStyles from '../../theme/useThemeStyles';

function PublicLegalDocument({ title, fileName, userType = 'both' }) {
  const styles = useThemeStyles();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadDocument = async () => {
      const fileNames = Array.isArray(fileName)
        ? fileName
        : fileName === 'cookie-policy'
          ? ['cookie-policy', 'cookies-policy']
          : [fileName];
      try {
        setLoading(true);
        setError('');
        let loaded = false;
        for (const currentFileName of fileNames) {
          try {
            const response = await api.get(`/api/legal/${currentFileName}`, {
              params: { userType },
              responseType: 'text',
              headers: { Accept: 'text/html, text/plain, */*' },
            });
            setContent(response.data || '');
            loaded = true;
            break;
          } catch {}
        }
        if (!loaded) {
          throw new Error('No matching legal document found');
        }
      } catch {
        setError('Failed to load document. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    loadDocument();
  }, [fileName, userType]);

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="320px">
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={2} sx={{ p: 4 }}>
        <Typography component="h1" className="pagename" sx={styles.text.pagename}>
          {title}
        </Typography>

        {error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <Box
            sx={{
              '& h1': { mt: 2, mb: 1.5, fontSize: '2rem', fontWeight: 600 },
              '& h2': { mt: 2, mb: 1, fontSize: '1.5rem', fontWeight: 600 },
              '& h3': { mt: 1.5, mb: 0.5, fontSize: '1.25rem', fontWeight: 600 },
              '& p': { mb: 1.5, lineHeight: 1.7 },
              '& ul, & ol': { mb: 1.5, pl: 3 },
              '& li': { mb: 0.5 },
              '& a': { color: 'primary.main', textDecoration: 'none' },
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </Paper>
    </Container>
  );
}

export default PublicLegalDocument;
